module.exports = __webpack_public_path__ + "a73b57a0e91ce23e1472814e7c83c2ba.pdf";